import '../styles/landing.css'

const testimonials = [
  {
    name: "ISABEL CARABEO",
    date: "28 de junio de 2026",
    rating: 5,
    text: "Es una excelente aplicación para estudiar y como dicen, atienden rápido a las dudas y solucionan rápido los detalles que uno pueda tener. En lo personal me está sirviendo de mucho. Éxito y muchas gracias por el apoyo.",
    avatar: "👩‍💻"
  },
  {
    name: "JR PORTILLO",
    date: "28 de febrero de 2026",
    rating: 5,
    text: "Es una excelente app y sus desarrolladores o el soporte sí solucionan rápido. Es una app muy buena, ya solucionaron los anuncios para la app premium.",
    avatar: "👨‍💼"
  },
  {
    name: "CERVERO DANTE",
    date: "3 de julio de 2026",
    rating: 5,
    text: "Es una excelente app, la recomiendo mucho, tiene todo lo que necesito y es muy económica, mejor que pagar 1800 o 2000 por otros cursos que venden por allá.",
    avatar: "👨‍💻"
  },
  {
    name: "ANGEL DANIEL JAIMES GARCIA",
    date: "20 de julio de 2026",
    rating: 5,
    text: "Excelente, me han apoyado a mí y a mi esposa. En todo.",
    avatar: "👨‍🚀"
  },
  {
    name: "AMANDA MORENO",
    date: "9 de julio de 2026",
    rating: 5,
    text: "Muy accesible y útil.",
    avatar: "👩‍💼"
  },
  {
    name: "HERNÁNDEZ MARTÍNEZ",
    date: "7 de julio de 2026",
    rating: 5,
    text: "Incluye conocimientos específicos de SSN.LENF.",
    avatar: "👨‍🏫"
  },
  {
    name: "OSCAR LASTRA",
    date: "14 de julio de 2026",
    rating: 5,
    text: "Excelente app, gracias.",
    avatar: "👨‍✈️"
  },
  {
    name: "MUSICA CRISTIANAS AGCH",
    date: "9 de agosto de 2026",
    rating: 5,
    text: "Genial.",
    avatar: "🎧"
  },
  {
    name: "JAC. TEBITA",
    date: "29 de mayo de 2026",
    rating: 5,
    text: "Muy bien.",
    avatar: "🧑‍✈️"
  },
  {
    name: "LUIS CHAVEZ",
    date: "25 de mayo de 2026",
    rating: 5,
    text: "Genial app.",
    avatar: "👨‍💻"
  }
]

export default function Testimonials() {
  return (
    <section id="testimonials" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Lo que dicen nuestros usuarios</h2>
          <p className="section-subtitle">
            Historias reales de personal que al igual que tú está en este proceso y está usando Ascensos App Vortex.
          </p>
        </div>

        <div className="grid grid-3">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-avatar">
                {testimonial.avatar}
              </div>
              {testimonial.rating && (
                <div className="testimonial-stars" aria-label={`${testimonial.rating} de 5 estrellas`}>
                  {'★'.repeat(testimonial.rating)}
                  <span style={{ color: 'var(--border)' }}>{'★'.repeat(5 - testimonial.rating)}</span>
                </div>
              )}
              <blockquote>
                "{testimonial.text}"
              </blockquote>
              <div className="testimonial-author">
                {testimonial.name}
              </div>
              {testimonial.date && (
                <div className="testimonial-date">
                  {testimonial.date}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="section-cta">
          <h3>Únete a Vortex y verás un camino con más posibilidades de éxito.</h3>
          <p>
            Comienza tu viaje hacia tu Ascenso hoy mismo.
          </p>
          <a href="#availability" className="btn btn-primary">
            Explorar aplicaciones
          </a>
        </div>
      </div>
    </section>
  )
}